module.exports = __webpack_public_path__ + "media/images/step-2-c17c9528d386f6a12e74c1d3ee148800.png";